import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type FrameworkApprovalAgentProps = {
  parsedContent: any;
};

type SubDimension = string;

type Dimension = {
  name: string;
  description: string;
  is_mandatory: boolean;
  sub_dimensions: SubDimension[];
};

type FrameworkData = {
  dimensions?: Dimension[];
  total_dimensions?: number;
  org_level_count?: number;
  dept_level_count?: number;
  role_type?: string;
  department?: string;
};

export default function FrameworkApprovalAgent({
  parsedContent,
}: FrameworkApprovalAgentProps): JSX.Element {
  // Parse the answer field
  const answer =
    typeof parsedContent?.answer === "string"
      ? safeJSONParse(parsedContent.answer)
      : parsedContent?.answer || {};

  const frameworkData: FrameworkData = answer;
  const dimensions = frameworkData.dimensions || [];
  const question = parsedContent?.question || parsedContent?.prompt;

  return (
    <div
      style={{
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      {/* Header Section */}
      {/* {(frameworkData.department || frameworkData.role_type) && (
        <div style={{ marginBottom: "20px" }}>
          <h2 style={{ marginBottom: "10px", color: "#004141" }}>
            {frameworkData.role_type &&
              frameworkData.role_type.charAt(0).toUpperCase() +
                frameworkData.role_type.slice(1)}{" "}
            Evaluation Framework
            {frameworkData.department && ` - ${frameworkData.department}`}
          </h2>
          {(frameworkData.total_dimensions !== undefined ||
            frameworkData.org_level_count !== undefined ||
            frameworkData.dept_level_count !== undefined) && (
            <div
              style={{
                display: "flex",
                gap: "20px",
                fontSize: "14px",
                color: "#536174",
                marginBottom: "10px",
              }}
            >
              {frameworkData.total_dimensions !== undefined && (
                <span>
                  <strong>Total Dimensions:</strong>{" "}
                  {frameworkData.total_dimensions}
                </span>
              )}
              {frameworkData.org_level_count !== undefined && (
                <span>
                  <strong>Organization Level:</strong>{" "}
                  {frameworkData.org_level_count}
                </span>
              )}
              {frameworkData.dept_level_count !== undefined && (
                <span>
                  <strong>Department Level:</strong>{" "}
                  {frameworkData.dept_level_count}
                </span>
              )}
            </div>
          )}
        </div>
      )} */}

      {/* Dimensions */}
      {dimensions.length > 0 && (
        <div style={{ marginBottom: "20px" }}>
          {dimensions.map((dimension: Dimension, idx: number) => (
            <div
              key={idx}
              style={{
                marginBottom: "24px",
                backgroundColor: "#f8f9fa",
                padding: "16px",
                borderRadius: "8px",
                borderLeft: dimension.is_mandatory
                  ? "4px solid #00d2aa"
                  : "4px solid #888",
              }}
            >
              {/* Dimension Header */}
              <h3
                style={{
                  color: "#004141",
                  fontSize: "16px",
                  fontWeight: 500,
                  margin: 0,
                  marginBottom: "10px",
                }}
              >
                {dimension.name}
              </h3>

              {/* Dimension Description */}
              {dimension.description && (
                <p
                  style={{
                    fontSize: "14px",
                    color: "#536174",
                    marginBottom: "12px",
                    lineHeight: "1.6",
                  }}
                >
                  {dimension.description}
                </p>
              )}

              {/* Sub-dimensions */}
              {Array.isArray(dimension.sub_dimensions) &&
                dimension.sub_dimensions.length > 0 && (
                  <div>
                    <h4
                      style={{
                        fontSize: "14px",
                        color: "#00d2aa",
                        marginBottom: "8px",
                        fontWeight: 500,
                      }}
                    >
                      Evaluation Criteria:
                    </h4>
                    <ul
                      style={{
                        margin: "0",
                        paddingLeft: "20px",
                        listStyle: "disc",
                      }}
                    >
                      {dimension.sub_dimensions.map(
                        (subDim: string, subIdx: number) => (
                          <li
                            key={subIdx}
                            style={{
                              fontSize: "14px",
                              color: "#403f3f",
                              marginBottom: "6px",
                              lineHeight: "1.6",
                            }}
                          >
                            {subDim}
                          </li>
                        ),
                      )}
                    </ul>
                  </div>
                )}
            </div>
          ))}
        </div>
      )}

      {/* Final Question */}
      {question && <div className={styles.finalQuestion}>{question}</div>}
    </div>
  );
}
